// extracted by mini-css-extract-plugin
module.exports = {"icons":"credit-card-icons_icons__8mKlp","icon":"credit-card-icons_icon___DWJG","withBorder":"credit-card-icons_withBorder__D7oQI","applepay":"credit-card-icons_applepay__c_ts_"};